<router-outlet></router-outlet>

<ngx-ui-loader
  bgsColor="#001e47"
  bgsPosition="bottom-right"
  bgsType="square-jelly-box"
  blur="0"
  delay="0"
  fastFadeOut="true"
  fgsColor="#001e47"
  fgsPosition="bottom-right"
  fgsType="square-jelly-box"
  logoPosition="bottom-right"
  logoUrl=""
  masterLoaderId="master"
  overlayColor="transparent"
  pbColor="transparent"
  text=""
  textColor="#001e47"
  textPosition="bottom-right"
  maxTime="-1"
  minTime="300"
  [bgsSize]="72"
  [fgsSize]="72"
  [bgsTemplate]="backgroundSpinner"
  [fgsTemplate]="foregroundSpinner"
>
</ngx-ui-loader>

<ng-template #backgroundSpinner>
  <app-loader></app-loader>
</ng-template>

<ng-template #foregroundSpinner>
  <app-loader></app-loader>
</ng-template>